// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"9d2e9f15","209":"0a486ef8","399":"5e24cfc3","625":"9c4af126","824":"f5ecd80e","912":"d39a39d1","922":"72786cd4"}[chunkId] + ".chunk.js";
};